import { useMessageStore } from '@/stores/message';
import { MessageHandlerMap, SocketMessage } from '@/types/socket/message';
import { FLAG_LENGTH, MESSAGE_HEADER_LENGTH, NO_EVENT_FLAGS, SKIP_PARSING_FLAGS } from '@/utils/constants/socket';

export const useSocketMessageHandler = (messageHandlerMap: MessageHandlerMap) => {
  const decoder = new TextDecoder();
  const messageStore = useMessageStore();

  const handleSocketMessage = async (rawMessage: string) => {
    const { flag, message } = parseSocketMessage(rawMessage);
    if (!isValidSocketMessage(flag, message)) {
      return;
    }

    const event = messageHandlerMap[flag];
    if (event) {
      await event(message);
    }
  };

  const parseSocketMessage = (data): SocketMessage => {
    try {
      if (data instanceof ArrayBuffer) {
        data = decoder.decode(data);
      }

      if (data.length < MESSAGE_HEADER_LENGTH) {
        throw new Error('Data length mismatch');
      }

      const flag = data.slice(0, FLAG_LENGTH);
      const message = data.substring(MESSAGE_HEADER_LENGTH);

      return {
        flag,
        message: SKIP_PARSING_FLAGS.includes(flag) ? message : JSON.parse(message),
      };
    } catch (e) {
      console.error('[SOCKET_PARSING_ERROR]', e, {
        rawData: data,
        dataLength: data?.length,
        dataType: typeof data,
      });
      return { flag: '', message: '' };
    }
  };

  const isValidSocketMessage = (flag: string, message: unknown): boolean => {
    return (
      !!flag &&
      !!message &&
      !NO_EVENT_FLAGS.includes(flag) &&
      (messageStore.status.isSocketReady || ['er', 'ca'].includes(flag))
    );
  };

  return {
    handleSocketMessage,
  };
};
